export default __webpack_public_path__ + "static/media/appleAppStoreLinkButtonGraphic.bcdf59ba.svg";